import { UserProfileState } from './partials/user-profile'

export const UserState = _ => ({
  ...UserProfileState,
})
